import { Tabs } from 'react-bootstrap';
import styled from 'styled-components';

export const PageTagsHeaderContainer = styled(Tabs)`
  margin-bottom: 32px;

  .nav-tabs {
    border-bottom: none;
  }

  .nav-tabs > li > a {
    font-size: 2rem;
    font-weight: 300;
    line-height: 1.1em;
    border: none;
    padding: 0;
  }

  .nav-tabs > li > a,
  .nav-tabs > li > a:focus,
  .nav-tabs > li > a:hover {
    background-color: transparent;
    border: none;
  }

  .nav-tabs > li > a:first-child {
    margin-right: 24px;
  }

  .nav-tabs > li:nth-child(2) > a {
    padding-left: 24px;
    border-left: 1px solid black;
    border-radius: 0;
  }

  .divider {
    margin: 16px 0;
    height: 1px;
    background-color: #e0e0e0;
  }
`;

export const PageHeaderButton = styled.button.attrs({
  className: 'btn btn-link',
})<{ $isActive: boolean }>`
  color: ${({ $isActive }) => ($isActive ? '#337ab7' : 'inherit')};
  font-size: 2rem;
  font-weight: 300;
  line-height: 1.1em;

  &:hover,
  &:focus {
    text-decoration: none;
    outline: none;
  }
`;
